import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StaticFileService {
  public base: string;
  public img: string;
  public js: string;
  public css: string;

  constructor() { }

  public init() {
    const hostname: string = window.location.hostname === 'localhost' ? window.location.host : window.location.hostname;
    const httpPrefix: string = hostname === 'localhost:5001' || hostname === 'localhost:8000' ? 'http://' : 'https://';
    this.base = `${httpPrefix}${hostname}/static/`;
    this.img = `${this.base}img/`;
    this.js = `${this.base}js/`;
    this.css = `${this.base}css/`;
  }
}
